<template>
  <div class="auth-wrapper">
    <section class="section">
      <h1 class="is-size-4 has-text-grey">
        {{ $t('Секунду... Авторизируемся') }}
        <span class="loader auth-wrapper-loader"></span>
      </h1>
    </section>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  async created () {
    try {
      await this.callback({ code: this.$route.query.code })
    } catch (e) {
      // console.log(e)
    }
    window.location.replace(`/`)
  },
  methods: {
    ...mapActions('authentication', ['callback'])
  }
}
</script>
